module.exports = __webpack_public_path__ + "static/media/about_layout-2.cbb4e8ed.png";